/**
 * @file: 坐标转换
 * @author: xiaolong.huang@dmall.com
 */

import * as Toolkit from '../toolkit/index';
import * as CubeTree from '../cubeTree/index';
import Utils from '../utils/util';
import Config from '../config/index';

const maxTopLine: LogicsicsMeasurement = Toolkit.cmToPx(Config.get({
    moduleName: 'shelf',
    key: 'maxHeight'
}));

const maxTopLinePhysics: PhysicsMeasurement = Config.get({
    moduleName: 'shelf',
    key: 'maxHeight'
});

// 物理坐标 -> 逻辑坐标
function physicsToLogic(coordinate: PhysicsCoordinate): LogicCoordinate {
    let bottomLine: number = Utils.math(coordinate.bottom, coordinate.height, '+');

    return {
        width: Toolkit.cmToPx(coordinate.width),
        height: Toolkit.cmToPx(coordinate.height),
        left: Toolkit.cmToPx(coordinate.left),
        top: Utils.math(maxTopLine, Toolkit.cmToPx(bottomLine), '-')
    };
}

// 逻辑坐标 -> 物理坐标
function logicToPhysics(coordinate: LogicCoordinate): PhysicsCoordinate {
    let topLine: number = Utils.math(maxTopLine, coordinate.top, '-');
    let bootomLine: number = Utils.math(topLine, coordinate.height, '-');

    return {
        width: Toolkit.pxToCm(coordinate.width),
        height: Toolkit.pxToCm(coordinate.height),
        left: Toolkit.pxToCm(coordinate.left),
        bottom: Toolkit.pxToCm(bootomLine)
    };
}

// 逻辑坐标 -> 渲染坐标
function logicToPaint(coordinate: LogicCoordinate): PaintCoordinate {
    let sketchpadHeight: PhysicsMeasurement = sketchpadPhysicsHeight();
    let overflowHeight: PhysicsMeasurement = Utils.math(maxTopLinePhysics, sketchpadHeight, '-');
    let overflowLogicHeight: LogicsicsMeasurement = Toolkit.cmToPx(overflowHeight);
    let scale: number = Config.get({
        moduleName: 'transform',
        key: 'scale'
    });
    let disX: LogicsicsMeasurement = Config.get({
        moduleName: 'transform',
        key: 'x'
    });
    let disY: LogicsicsMeasurement = Config.get({
        moduleName: 'transform',
        key: 'y'
    });
    let left: LogicsicsMeasurement = Utils.math(coordinate.left, scale, '*');
    let top: LogicsicsMeasurement = Utils.math(Utils.math(coordinate.top, overflowLogicHeight, '-'), scale, '*');

    return {
        width: Utils.math(scale, coordinate.width, '*'),
        height: Utils.math(scale, coordinate.height, '*'),
        left: Utils.math(left, disX, '+'),
        top: Utils.math(top, disY, '+')
    };
}

// 渲染坐标 -> 逻辑坐标
function paintToLogic(coordinate: PaintCoordinate): LogicCoordinate {
    let sketchpadHeight: PhysicsMeasurement = sketchpadPhysicsHeight();
    let overflowHeight: PhysicsMeasurement = Utils.math(maxTopLinePhysics, sketchpadHeight, '-');
    let overflowLogicHeight: LogicsicsMeasurement = Toolkit.cmToPx(overflowHeight);
    let scale: number = Config.get({
        moduleName: 'transform',
        key: 'scale'
    });
    let disX: LogicsicsMeasurement = Config.get({
        moduleName: 'transform',
        key: 'x'
    });
    let disY: LogicsicsMeasurement = Config.get({
        moduleName: 'transform',
        key: 'y'
    });

    let left: LogicsicsMeasurement = Utils.math(coordinate.left, disX, '-');
    let top: LogicsicsMeasurement = Utils.math(coordinate.top, disY, '-');

    left = Utils.math(left, scale, '/');
    top = Utils.math(top, scale, '/');
    top = Utils.math(top, overflowLogicHeight, '+');

    return {
        width: Utils.math(coordinate.width, scale, '/'),
        height: Utils.math(coordinate.height, scale, '/'),
        left: left,
        top: top
    };
}

const paintToPhysics: (coordinate: PaintCoordinate) => PhysicsCoordinate = Utils.createComposeFunc(logicToPhysics, paintToLogic);

// 计算货架区域逻辑高度，取最高的货架高度
function sketchpadPhysicsHeight(): PhysicsMeasurement {
    return Config.get({
        moduleName: 'shelf',
        key: 'shelfAreaHeight'
    });
}

export {
    physicsToLogic,
    logicToPhysics,
    logicToPaint,
    paintToLogic,
    paintToPhysics,
    sketchpadPhysicsHeight
};
